/**
 * Normalize keg asset tags (imported Ekos serials like EK09503).
 * Canonical display + storage form: uppercase, trimmed, no internal spaces
 * so 'Ek09802' and 'EK09802' are the same keg everywhere.
 */
export function normalizeKegCode(raw: string | null | undefined): string {
  return String(raw || '')
    .trim()
    .toUpperCase()
    .replace(/\s+/g, '');
}

export function isValidKegCode(raw: string | null | undefined): boolean {
  const code = normalizeKegCode(raw);
  return Boolean(code) && /^[A-Z0-9-]+$/.test(code);
}
